import React, { useEffect, useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  FlatList,
} from "react-native";
import moment from "moment";
import { AntDesign, Entypo } from "@expo/vector-icons";
import EditCalendar from "./editCalendar";
import AddResearch from "./addResearch";
import { Modal } from "react-native-web";
import { univer, userState } from "../reducer";
import { useRecoilState } from "recoil";
import { apiservice } from "../service/api";
import { useIsFocused } from "@react-navigation/native";
const { width, height } = Dimensions.get("window");

const manageCalendar = () => {
  const [modal, setmodal] = useState(false);
  const [university, setUniversity] = useRecoilState(univer);
  const [user, serUsers] = useRecoilState(userState);
  const [page, setpage] = useState(0);
  const [state, setstate] = useState({});
  const [data1, setdata] = useState([]);
  const [fill, setfill] = useState("");
  const isFocus = useIsFocused();

  async function getallUniversity() {
    const res = await apiservice({
      path: "/calender/getall?university_id=" + user.university_id,
      method: "get",
    });
    if (res.status == 200) {
      setdata(res.data.result);
    }
  }

  useEffect(() => {
    getallUniversity();
  }, [isFocus, page]);

  async function deleteUniversity() {
    const res = await apiservice({
      path: "/calender/delete/" + state.id,
      method: "delete",
    });
    if (res.status == 200) {
      getallUniversity();
      setmodal(false);
    }
  }

  return (
    <View style={styles.container}>
      <Modal
        animationType="none"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          setmodal(!modal);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              ต้องการลบข้อมูลนี้ใช่หรือไหม
            </Text>
            <View
              style={{
                width: width * 0.25,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  deleteUniversity();
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Bold",
              color: "#202020",
            }}
          >
            ปฏิทิน
          </Text>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.06,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: width * 0.235,
                height: height * 0.037,
                flexDirection: "row",
              }}
            >
              <TextInput
                onChangeText={(text) => setfill(text)}
                defaultValue={fill}
                style={{
                  width: width * 0.8,
                  height: height * 0.037,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#00237740",
                  paddingLeft: 5,
                  fontFamily: "Prompt-Regular",
                  fontSize: 12,
                }}
              />
              <TouchableOpacity
                style={{
                  width: width * 0.022,
                  height: height * 0.037,
                  backgroundColor: "#002377",
                }}
              >
                <AntDesign
                  name="search1"
                  style={{ margin: "auto" }}
                  size={15}
                  color="#ffff"
                />
              </TouchableOpacity>
            </View>
            <TouchableOpacity
              onPress={() => setpage(1)}
              style={{
                width: width * 0.075,
                height: height * 0.037,
                backgroundColor: "#43A2D4",
                borderRadius: 5,
              }}
            >
              <Text style={styles.TextButton}>+ เพิ่มหัวข้อ</Text>
            </TouchableOpacity>
          </View>

          <View
            style={{
              width: width * 0.591,
              height: height * 0.546,
              borderWidth: 1,
              overflow: "hidden",
              borderColor: "#C2C2C2",
              borderTopLeftRadius: 5,
              borderTopRightRadius: 5,
            }}
          >
            <View
              style={{
                width: width * 0.591,
                height: height * 0.054,
                backgroundColor: "#002377",
                flexDirection: "row",
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
              }}
            >
              <View style={{ width: width * 0.123, height: height * 0.054 }}>
                <Text
                  style={[styles.Textheader, { color: "#FFF" }]}
                >
                  หัวข้อ
                </Text>
              </View>
              <View style={{ width: width * 0.123, height: height * 0.054 }}>
                <Text
                  style={[styles.Textheader, { color: "#FFF" }]}
                >
                  วัน - เวลา
                </Text>
              </View>
              <View style={{ width: width * 0.095, height: height * 0.054 }}>
                <Text
                  style={[styles.Textheader, { color: "#FFF" }]}
                >
                  สถานที่
                </Text>
              </View>
              <View style={{ width: width * 0.125, height: height * 0.054 }}>
                <Text
                  style={[styles.Textheader, { color: "#FFF" }]}
                >
                  วิทยากร
                </Text>
              </View>
              <View style={{ width: width * 0.125, height: height * 0.054 }}>
                <Text
                  style={[styles.Textheader, { color: "#FFF" }]}
                >
                  จัดการ
                </Text>
              </View>
            </View>

            <FlatList
              data={data1.filter((item) => item.name.includes(fill))}
              renderItem={({ item, index }) => {
                return (
                  <View
                    style={{
                      width: width * 0.591,
                      height: height * 0.06,
                      flexDirection: "row",
                      backgroundColor: index % 2 == 0 ? "#ffff" : "#E8E8E8",
                    }}
                  >
                    <View
                      style={{ width: width * 0.123, height: height * 0.06 }}
                    >
                      <Text style={styles.Textdata} numberOfLines={1}>{item.name}</Text>
                    </View>
                    <View
                      style={{ width: width * 0.123, height: height * 0.06 }}
                    >
                      <Text style={styles.Textdata}>
                        {moment(item.date)
                          .add(543, "years")
                          .format("DD/MM/YYYY")}
                      </Text>
                      <Text style={styles.Textdata}>
                        {item.starttimehour}:{item.starttimeminute} -{" "}
                        {item.endtimehour}:{item.endtimeminute} น.
                      </Text>
                    </View>
                    <View
                      style={{ width: width * 0.095, height: height * 0.06 }}
                    >
                      <Text style={styles.Textdata}>{item.place}</Text>
                    </View>
                    <View
                      style={{ width: width * 0.125, height: height * 0.06 }}
                    >
                      <Text style={styles.Textdata}>{item.create_by}</Text>
                    </View>
                    <View
                      style={{
                        width: width * 0.125,
                        height: height * 0.06,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <TouchableOpacity
                        onPress={() => {
                          setstate(item);
                          setpage(2);
                        }}
                        style={{
                          width: 70,
                          height: 30,
                          borderRadius: 5,
                          backgroundColor: "#002377",
                        }}
                      >
                        <Text
                          style={[
                            styles.TextButton,
                            {
                              color: "#FFF",
                            },
                          ]}
                        >
                          แก้ไข
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        onPress={() => {
                          setstate(item);
                          setmodal(true);
                        }}
                        style={{
                          width: 70,
                          height: 30,
                          borderRadius: 5,
                          backgroundColor: "#D44343",
                        }}
                      >
                        <Text style={styles.TextButton}>ลบ</Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                );
              }}
            />
          </View>
        </View>
      )}

      {page == 1 && <AddResearch setpages={setpage} />}
      {page == 2 && <EditCalendar state={state} setpages={setpage} />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Textheader: {
    fontSize: 20,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
  Textdata: { fontSize: 16, margin: "auto", fontFamily: "Prompt-Regular" },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});
export default manageCalendar;
